import { render, staticRenderFns } from "./auth-register.vue?vue&type=template&id=90530740&"
import script from "./auth-register.vue?vue&type=script&lang=js&"
export * from "./auth-register.vue?vue&type=script&lang=js&"
import style0 from "./auth-register.vue?vue&type=style&index=0&id=90530740&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports